export default (x, y) => `transform: translate(${x}vw, ${y}vw)`